import InfoLayout from './InfoLayout';

export default InfoLayout;
